// extracted by mini-css-extract-plugin
export default {"salaryInputContainer":"SalaryInput_salaryInputContainer__yXP7C"};